<template>
  <v-container id="employee-report" fluid tag="section">
    <FilterForm :filterForm="filterForm" />

    <ContactSourceReportTable
      :dataReport="dataReport"
    />

  </v-container>
</template>

<script>
import TokenService from '../../../../helpers/token';
import * as moment from 'moment'
import { formatDate } from '@/helpers/utils'
import FilterForm from './components/FilterForm'
import ContactSourceReportTable from './components/ContactSourceReportTable'

import RepositoryFactory from "@/repositories/RepositoryFactory";
const ReportRepository = RepositoryFactory.get('report');

export default {
  components: { FilterForm, ContactSourceReportTable },
  data () {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        },
        departmentId: '',
        departmentIds: [],
        shift: []
      },
      dataReport: {},
    }
  },

  created () {
    Bus.$on('contact-source-report-filter-thpt', (filterForm) => {
      this.filterForm = filterForm
      this.fetchData()
    })
  },
  beforeDestroy() {
    Bus.$off('contact-source-report-filter-thpt');
  },
  methods: {

    async fetchData () {
      const loader = this.$loading.show()

      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        shift: this.filterForm.shift,
        departmentIds: this.filterForm.departmentIds,
        schoolLevelIds: [2]
      }

      // if (!this.isManager()) {
      //   if (this.filterForm.departmentId == 0 ) {
      //     this.filterForm.departmentId = '';
      //   }
      //   const dataUser = TokenService.getUser() || {};
      //   params.departmentId = dataUser.departmentId;
      // }

      const response = await ReportRepository.contactSource(params)

      loader.hide()

      if (_.get(response, 'success', false)) {
        this.dataReport = _.get(response, 'data', {})
      } else {
        this.dataReport = {}
      }
    },
  },
}
</script>
